// extracted by mini-css-extract-plugin
export default {"featurePanel":"AccountSummary_featurePanel__oAF8F"};